  
<template>
    <div>
        <div v-html="stylesOverride"></div>
        <div ref="carousel" class="center-carousel" v-if="comments.length > 1">
            <div v-for="(comment, index) in comments" v-bind:key="comment" class="carousel-item">
                <video v-if="comment.video" controls
                       @click="clickOnVideo()" @play="videoStarts()" @pause="videoStops()">
                    <source :src="comment.video" type="video/mp4" alt="">
                </video>
                <img v-if="(comment.url_body || comment.image) && !comment.video" :alt="comment.alt_text? comment.alt_text : ``" :src="comment.url_body? comment.url_body : comment.image" class="img-responsive carrusel"
                     data-toggle="tooltip" data-offset="0,10" :data-original-title="comment.alt_text? comment.alt_text : ``" :id="'tooltip-carrusel-' + id + '-' + index"
                     />
                <b-tooltip class="tooltip1" :target="'tooltip-carrusel-' + id + '-' + index" placement="right">
                    {{ comment.alt_text || course_name }}
                </b-tooltip>
                <div v-if="comment.text && comment.author" alt="" class="comment-block d-none d-sm-block">
                    <div class="top">
                        <p class="text-left m-0-bottom">{{comment.text}}</p>
                    </div>
                    <div class="bottom">
                        <label>{{comment.author}}</label>
                    </div>
                </div>
                <div v-if="comment.content" class="comment-block d-none d-sm-blocks">
                    <div class="top">
                        <p class="text-left m-0-bottom" v-html="comment.content"></p>
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="my-4">
            <div v-for="(comment, index) in comments" v-bind:key="comment">
                <video v-if="comment.video" controls
                       @click="clickOnVideo()" @play="videoStarts()" @pause="videoStops()">
                    <source :src="comment.video" type="video/mp4" alt="">
                </video>
                <img v-if="(comment.url_body || comment.image) && !comment.video" :alt="comment.alt_text? comment.alt_text : ``" :src="comment.url_body? comment.url_body : comment.image" class="img-responsive carrusel"
                     data-toggle="tooltip" data-offset="0,10" :data-original-title="comment.alt_text? comment.alt_text : ``" :id="'tooltip-carrusel-' + id + '-' + index"
                     >
                <b-tooltip class="tooltip1" :target="'tooltip-carrusel-' + id + '-' + index" placement="right" >
                    {{ comment.alt_text || course_name }}
                </b-tooltip>

                <div v-if="comment.text && comment.author" alt="" class="comment-block d-none d-sm-block">
                    <div class="top">
                        <p class="text-left m-0-bottom">{{comment.text}}</p>
                    </div>
                    <div class="bottom">
                        <label>{{comment.author}}</label>
                    </div>
                </div>
                <div v-if="comment.content" class="comment-block d-none d-sm-blocks">
                    <div class="top">
                        <p class="text-left m-0-bottom" v-html="comment.content"></p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "CourseImagesCarousel",
    props: ['comments', 'showReview'],
    mounted: function () {
        console.log("Esto trae comments: ", this.comments);
        let promises = [];
        this.comments.forEach((item) => {
            if (item.image) {
                let img = new Image();
                img.src = item.image;
                let promise = new Promise((resolve)=> {
                    img.onload = () => {
                        resolve();
                    }
                });

                promises.push(promise);
            }
        });

        Promise.all(promises).then(() => {
            //TODO: wait until everything load?
            //this.init();
        });

        this.init();
    },
    computed: {
        stylesOverride() {
            let styles = '';
            let filtersColor = _.get(this.$parent, 'corporation.color_filters', null);
            if (filtersColor) {

                styles = `<style>
                            .course .center-carousel .slick-dots li.slick-active button {
                                background-color: ${filtersColor};
                             }

                             .course .center-carousel .slick-dots li button {
                              border-color: ${filtersColor};
                             }
                         </style>`;
            }

            return styles;
        },
        id() {
            return this._uid;
        },
        course_name() {
            return this.$parent && this.$parent.course ? this.$parent.course.course_name : '';
        },
    },
    methods: {
        init() {
            //Init slider
            $(this.$refs.carousel).slick({
                dots: true,
                infinite: true,
                speed: 1000,
                autoplaySpeed : 5000,
                fade: false,
                cssEase: 'linear',
                prevArrow: '',
                autoplay: true,
                nextArrow:'',
                responsive: [
                    {
                        breakpoint: 480,
                        settings: {
                            adaptiveHeight: true
                        }
                    }
                ]
            });
        },
        videoStarts: function () {
            //this.showReview = false;
        },
        videoStops: function () {
            //this.showReview = true;
        },
        clickOnVideo: function () {
            console.log('click on video');
            //TODO: stop/play
        }
    },
}
</script>

<style scoped>   
    img {          
        object-fit: cover;
        max-width: 100%;        
    }    
    .carrusel{
      color: #383838;
      font-family: Source Sans Pro;
      font-size: 40px;
      line-height: 46px;
    }
    @media (min-width: 420px) {
    img {
            width: 420px;
            height: 150px;
        }
    }
    @media (min-width: 320px) and (max-width: 480px) {
  
    img {           
            width: 420px;
            height: 150px;            
        }
    
    }    
    @media (min-width: 760px) {
        img  {
            /* max-width: 100%; */
              width: 1050px;
              height: 300px;      
        }
    }
</style>